import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAddress = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.002 2c1.762.01 3.491.477 5.018 1.355a10.14 10.14 0 0 1 3.686 3.65c2.22 3.66 1.257 6.901-.442 8.546-.813.786-1.909 1.299-2.926 1.064a2.05 2.05 0 0 1-1.299-.947 2.5 2.5 0 0 1-.184-.363 5.03 5.03 0 0 1-4.736 1.623 5.04 5.04 0 0 1-2.577-1.35 5.015 5.015 0 0 1-1.145-5.442c.369-.919 1-1.708 1.817-2.27a5.04 5.04 0 0 1 7.496 2.193A5 5 0 0 1 17.1 12v1.85c0 .53.106.851.217 1.032.102.166.223.24.358.272.32.073.918-.075 1.546-.681 1.179-1.141 2.072-3.61.2-6.694l-.006-.01a8.64 8.64 0 0 0-3.143-3.114A8.7 8.7 0 0 0 11.997 3.5 8.55 8.55 0 0 0 5.42 6.627a8.49 8.49 0 0 0-1.75 7.052 8.5 8.5 0 0 0 1.52 3.4 8.546 8.546 0 0 0 10.117 2.767.75.75 0 0 1 .576 1.385A10.05 10.05 0 0 1 3.99 17.978a9.99 9.99 0 0 1-1.695-8.382 10 10 0 0 1 1.965-3.919A10.049 10.049 0 0 1 11.996 2zm3.599 10a3.5 3.5 0 0 0-1.054-2.509 3.53 3.53 0 0 0-2.536-1.01 3.54 3.54 0 0 0-1.947.622 3.508 3.508 0 0 0-.472 5.405 3.535 3.535 0 0 0 3.843.737 3.53 3.53 0 0 0 1.575-1.297A3.5 3.5 0 0 0 15.6 12"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgAddress;
